import { call, put, select, takeEvery } from "redux-saga/effects";
import {
  getFilteredPlans,
  hidePlansDataLoader,
  hideMediaBuyerPlansFilterDataLoader,
  hideMediaBuyerPlansParamsLoader,
  setPlans,
  setMediaBuyerPlansFilterData,
  setMediaBuyerPlansForId,
  setPlansOffer,
  showPlansDataLoader,
  showMediaBuyerPlansFilterDataLoader,
  showMediaBuyerPlansParamsLoader,
  setProfitLoadingProcess,
  setMediaBuyerProfit,
  setPlansProfitFilterData,
  PayoutConditionLoader,
  setPayoutCondition,
} from "./actions";
import {
  deleteMediaBuyerPlans,
  getFilteredMediaBuyerPlans,
  getMediaBuyerPlanByBudgetId,
  getPlansOffers,
  getMediaBuyerPlansParams,
  patchPlanOffer,
  postMediaBuyerPlan,
  getPlansMediaBuyers,
  getPlansOffersById,
  patchPlanMediaBuyer,
  getMediaBuyerPlanProfit,
  postPlansMediaBuyersVoucher,
  patchPlansMediaBuyersVoucher,
  getPayoutConditionsMediaBuyer,
  patchPayoutConditionMediaBuyer,
  postPayoutCondition,
  deletePayoutConditionMediaBuyer,
  postPayoutConditionMediaBuyer,
  delPlansMediaBuyersVoucher,
} from "../../../helpers/jwt_helper";
import {
  ADD_MEDIA_BUYER_PLAN,
  ADD_MEDIA_BUYER_PLAN_BY_OFFER,
  DELETE_MEDIA_BUYER_PLAN,
  DELETE_MEDIA_BUYER_PLAN_BY_OFFER,
  GET_FILTERED_MEDIA_BUYER_PLAN,
  GET_MEDIA_BUYER_PLAN_FOR_ID,
  GET_PLANS,
  GET_MEDIA_BUYER_PLANS_FILTER_DATA,
  GET_MEDIA_BUYER_PLANS_PARAMS,
  INIT_MEDIA_BUYER_PLANS,
  PATCH_PLAN,
  PATCH_MEDIA_BUYER_PLANS_FILTER_DATA,
  SET_MEDIA_BUYER_PLANS_NESTING,
  GET_MEDIA_BUYER_PROFIT,
  EDIT_CUSTOM_PROFIT_LOCAL,
  CLOSE_CUSTOM_PROFIT_LOCAL,
  ADD_MEDIA_BUYER_VOUCHER,
  UPDATE_MEDIA_BUYER_VOUCHER,
  GET_PAYOUT_CONDITIONS_MEDIA_BUYER,
  UPDATE_PAYOUT_CONDITIONS_MEDIA_BUYER,
  DELETE_PAYOUT_CONDITIONS_MEDIA_BUYER,
  ADD_PAYOUT_CONDITIONS_MEDIA_BUYER,
  DELETE_MEDIA_BUYER_VOUCHER,
  TRIGGER_MEDIA_BUYER_VOUCHER,
} from "./actionType";
import {
  changeQuery,
  getErrorMessage,
  showErrorMessage,
  showSuccessMessage,
} from "../../../helpers/utils";

const hasOfferId = data =>
  typeof data.offer === "number" ||
  ("offer" in data && data.offer?.length > 0 && +data.offer >= 0);

function* onGetPlans({ payload } = {}) {
  try {
    // let params = yield select((state) => state.MediaBuyerPlans.params)
    // const filterData = yield select((state) => state.MediaBuyerPlans.filterData)
    const data = {
      ...(yield select(state => state.MediaBuyerPlans.data)),
      ...payload,
    };
    delete data.results;
    yield put(showPlansDataLoader());
    // console.log({ data })

    delete data.next;
    delete data.previous;
    delete data.count;

    let response = undefined;
    if (hasOfferId(data)) {
      response = yield call(getPlansMediaBuyers, data);
      changeQuery({ offer: data.offer });
    } else {
      response = yield call(getPlansOffers, data);
      changeQuery({ offer: undefined });
    }

    response = {
      ...data,
      ...response,
    };
    delete response.offer;
    yield put(setPlans(response));
    yield put(hidePlansDataLoader());
  } catch (e) {
    showErrorMessage(getErrorMessage(e));
    yield put(hidePlansDataLoader());
  }
}

function* onPatchPlan({ payload: { offer_id, id, data } }) {
  try {
    const store_data = yield select(state => state.MediaBuyerPlans.data);

    let res = undefined;
    if (hasOfferId({ offer: offer_id })) {
      res = yield call(patchPlanMediaBuyer, id, data);
    } else {
      res = yield call(patchPlanOffer, id, data);
    }

    store_data.results = store_data.results.map(i =>
      i.id === res.id ? res : i
    );
    yield put(setPlans({ ...store_data }));

    showSuccessMessage(`Updating media buyer plan ${id} has been successfully`);
  } catch (e) {
    showErrorMessage(getErrorMessage(e));
  }
}

function* onGetProfitPlans({ payload }) {
  try {
    payload = {
      ...(yield select(state => state.MediaBuyerPlans.profitFilterData)),
      ...payload,
    };
    yield put(setProfitLoadingProcess());
    let data = [];
    let response = yield call(getMediaBuyerPlanProfit, payload);
    response.forEach((i, idx) => {
      data.push(i);

      if (i.is_sum && idx + 2 !== response.length) {
        data.push({
          empty: true,
        });
      }
    });
    yield put(setPlansProfitFilterData(payload));
    yield put(setMediaBuyerProfit({ results: data }));
    yield put(setProfitLoadingProcess());
  } catch (e) {
    yield put(setProfitLoadingProcess());
    showErrorMessage(getErrorMessage(e));
  }
}

/*function* onDeleteMediaBuyerPlan({ payload: { id, data } }) {
  try {
    yield put(showMediaBuyerPlanLoader())
    yield call(deleteMediaBuyerPlans, id)
    yield call(onGetMediaBuyersPlans, { payload: data })
    yield put(hideMediaBuyerPlanLoader())
    showSuccessMessage(`Deleting media buyer plan ${id} has been successfully`)
  } catch (error) {
    showErrorMessage(getErrorMessage(error))
    yield put(hideMediaBuyerPlanLoader())
  }
}*/

function* onGetMediaBuyerPlanParams({ payload = {} } = {}) {
  try {
    // let data = yield select((state) => state.MediaBuyerPlans.data);
    yield put(showMediaBuyerPlansParamsLoader());
    const res = yield call(getMediaBuyerPlansParams, payload);
    yield put(setPlansOffer(res));
    yield put(hideMediaBuyerPlansParamsLoader());
    return res;
  } catch (e) {
    showErrorMessage(getErrorMessage(e));
    yield put(hidePlansDataLoader());
  }
}

function* onInitMediaBuyerPlan({ payload: { init_data = {} } }) {
  try {
    if (hasOfferId(init_data)) {
      yield onGetPlansOfferById(+init_data.offer);
    }
    yield onGetPlans({ payload: init_data });
  } catch (e) {
    console.error(e);
  }
}

function* onGetMediaBuyerPlanOffers({ payload } = {}) {
  try {
    yield put(showMediaBuyerPlansFilterDataLoader());
    let res = yield call(getPlansOffers, { ...payload, page: 1, size: 999999 });
    res = res.results.map(i => ({
      value: i.id,
      label: i.name,
      checked: false,
    }));
    yield put(setMediaBuyerPlansFilterData({ options: res }));
    yield put(hideMediaBuyerPlansFilterDataLoader());
    return res;
  } catch (e) {
    console.error(e);
    return [];
  }
}

function* onPatchMediaBuyerPlanFilterData({ payload } = {}) { }

function* onGetPlansOfferById(offer_id) {
  try {
    const res = yield call(getPlansOffersById, offer_id);
    yield put(setPlansOffer(res));
  } catch (e) {
    showErrorMessage(e);
    yield onSetMediaBuyerNesting({ payload: null });
  }
}

function* onSetMediaBuyerNesting({ payload }) {
  try {
    yield put(setPlansOffer(payload));
    yield onGetPlans({ payload: { offer: payload?.id } });
  } catch (e) {
    console.log(e);
  }
}

function* onEditCustomMBProfit({ payload: index }) {
  try {
    let currentData = yield select(state => state.MediaBuyerPlans.profit_data);
    let object = currentData.results[index];
    Object.assign(object, {
      ...object,
      can_edit: true,
    });
    currentData[index] = object;
    yield put(
      setMediaBuyerProfit({
        results: [...currentData.results],
      })
    );
  } catch (error) {
    showErrorMessage(getErrorMessage(error));
  }
}

function* onCloseEditCustomMBProfit({ payload: idx }) {
  try {
    let currentData = yield select(state => state.MediaBuyerPlans.profit_data);
    let object = currentData.results[idx];
    delete object["can_edit"];
    currentData[idx] = object;
    yield put(
      setMediaBuyerProfit({
        results: [...currentData.results],
      })
    );
  } catch (error) {
    showErrorMessage(getErrorMessage(error));
  }
}

function* onAddMediaBuyerVoucher({ payload: data }) {
  try {
    let res = yield call(postPlansMediaBuyersVoucher, data);
    yield call(onGetProfitPlans, {});
    showSuccessMessage(
      `The voucher for the \"${data[0].offer_name || "Empty"
      }\" has been successfully added`
    );
  } catch (e) {
    showErrorMessage(getErrorMessage(e));
  }
}

function* onUpdateMediaBuyerVoucherTrigger({ payload: data }) {
  try {
    const { drop, add, patch, filters } = data;

    if (drop?.length > 0) {
      yield call(delPlansMediaBuyersVoucher, drop.join(","));
    }

    if (add?.length > 0) {
      yield call(postPlansMediaBuyersVoucher, data.add);
    }

    if (patch?.length > 0) {
      yield call(patchPlansMediaBuyersVoucher, patch);
    }

    yield call(onGetProfitPlans, { ...filters });

    showSuccessMessage(
      `The voucher has been successfully updated`
    );

  } catch (error) {
    showErrorMessage(getErrorMessage(error));
  }
}

function* onUpdateMediaBuyerVoucher({ payload: { id, data } }) {
  try {
    let res = yield call(patchPlansMediaBuyersVoucher, data);
    yield call(onGetProfitPlans, {});
    showSuccessMessage(
      `The voucher for the \"${data[0].offer_name || "Empty"
      }\" has been successfully updated`
    );
  } catch (e) {
    showErrorMessage(getErrorMessage(e));
  }
}

function* onDeleteMediaBuyerVoucher({ payload: { ids } }) {
  try {
    let res = yield call(delPlansMediaBuyersVoucher, { ids });
    yield call(onGetProfitPlans, {});
    showSuccessMessage(
      `The voucher has been successfully updated`
    );
  } catch (e) {
    showErrorMessage(getErrorMessage(e));
  }
}

function* onGetPayoutConditions({ payload: data }) {
  try {
    yield put(PayoutConditionLoader());
    let response = yield call(getPayoutConditionsMediaBuyer, {
      page: data.page,
      size: data.sizePerPage,
      ordering: data.ordering,
      search: data.search,
      ...(data?.for_yourself && {
        for_yourself: data.for_yourself,
      }),
    });
    response = {
      ...data,
      ...response,
      results: response.results.map(i => ({
        ...i,
        created_at: new Date(i.created_at).toDateString(),
      })),
    };
    yield put(setPayoutCondition(response));
    yield put(PayoutConditionLoader());
  } catch (error) {
    showErrorMessage(getErrorMessage(error));
    yield put(PayoutConditionLoader());
  }
}

function* onUpdatePayoutCondition({ payload: data }) {
  try {
    let currentData = yield select(state => state.MediaBuyerPlans.payoutData);
    yield put(PayoutConditionLoader());
    yield call(patchPayoutConditionMediaBuyer, data);
    yield call(onGetPayoutConditions, {
      payload: currentData,
    });
    yield put(PayoutConditionLoader());
    showSuccessMessage("Payout condition has been updated");
  } catch (error) {
    yield put(PayoutConditionLoader());
    showErrorMessage(getErrorMessage(error));
  }
}
function* onAddPayoutCondition({ payload: data }) {
  try {
    yield put(PayoutConditionLoader());
    let currentData = yield select(state => state.MediaBuyerPlans.payoutData);
    yield call(postPayoutConditionMediaBuyer, data);
    yield call(onGetPayoutConditions, {
      payload: currentData,
    });
    showSuccessMessage("Payout condition has been added successfully");
    yield put(PayoutConditionLoader());
  } catch (error) {
    showErrorMessage(getErrorMessage(error));
    yield put(PayoutConditionLoader());
  }
}
function* onDeletePayoutConditions({ payload: data }) {
  try {
    let params = {
      ids: data.join(","),
    };
    yield put(PayoutConditionLoader());
    let currentData = yield select(state => state.MediaBuyerPlans.payoutData);
    yield call(deletePayoutConditionMediaBuyer, params);
    yield call(onGetPayoutConditions, {
      payload: currentData,
    });
    showSuccessMessage(
      `Payout${data.length === 1 ? "condition" : "conditions"
      } has been deleted successfully`
    );
    yield put(PayoutConditionLoader());
  } catch (error) {
    showErrorMessage(getErrorMessage(error));
    yield put(PayoutConditionLoader());
  }
}

function* mediaBuyersPlansSaga() {
  yield takeEvery(PATCH_PLAN, onPatchPlan);
  // yield takeEvery(GET_MEDIA_BUYER_PLAN_FOR_ID, onGetMediaBuyerPlanForId)
  yield takeEvery(GET_PLANS, onGetPlans);
  // yield takeEvery(ADD_MEDIA_BUYER_PLAN, onPostMediaBuyerPlan)
  // yield takeEvery(DELETE_MEDIA_BUYER_PLAN, onDeleteMediaBuyerPlan)
  // yield takeEvery(GET_FILTERED_MEDIA_BUYER_PLAN, onFilteredPlans)
  // yield takeEvery(ADD_MEDIA_BUYER_PLAN_BY_OFFER, onPostMediaBuyerPlanByOffer)
  // yield takeEvery(DELETE_MEDIA_BUYER_PLAN_BY_OFFER, onDeleteMediaBuyerPlanByOffer)
  yield takeEvery(SET_MEDIA_BUYER_PLANS_NESTING, onSetMediaBuyerNesting);
  yield takeEvery(GET_MEDIA_BUYER_PLANS_PARAMS, onGetMediaBuyerPlanParams);
  // yield takeEvery(GET_MEDIA_BUYER_PLANS_FILTER_DATA, onGetMediaBuyerPlanFilterData)
  yield takeEvery(
    PATCH_MEDIA_BUYER_PLANS_FILTER_DATA,
    onPatchMediaBuyerPlanFilterData
  );
  yield takeEvery(INIT_MEDIA_BUYER_PLANS, onInitMediaBuyerPlan);
  yield takeEvery(GET_MEDIA_BUYER_PROFIT, onGetProfitPlans);
  yield takeEvery(EDIT_CUSTOM_PROFIT_LOCAL, onEditCustomMBProfit);
  yield takeEvery(CLOSE_CUSTOM_PROFIT_LOCAL, onCloseEditCustomMBProfit);
  yield takeEvery(ADD_MEDIA_BUYER_VOUCHER, onAddMediaBuyerVoucher);
  yield takeEvery(UPDATE_MEDIA_BUYER_VOUCHER, onUpdateMediaBuyerVoucher);
  yield takeEvery(GET_PAYOUT_CONDITIONS_MEDIA_BUYER, onGetPayoutConditions);
  yield takeEvery(
    UPDATE_PAYOUT_CONDITIONS_MEDIA_BUYER,
    onUpdatePayoutCondition
  );
  yield takeEvery(ADD_PAYOUT_CONDITIONS_MEDIA_BUYER, onAddPayoutCondition);
  yield takeEvery(
    DELETE_PAYOUT_CONDITIONS_MEDIA_BUYER,
    onDeletePayoutConditions
  );
  yield takeEvery(DELETE_MEDIA_BUYER_VOUCHER, onDeleteMediaBuyerVoucher);
  yield takeEvery(TRIGGER_MEDIA_BUYER_VOUCHER, onUpdateMediaBuyerVoucherTrigger); //
}

export default mediaBuyersPlansSaga;
